import { useRef } from "react";
import { useSelector } from "react-redux";
import { Modal, ModalOverflow } from "@financeable-com-au/financeable-ui";
import { lodgeAISelector } from "@/store/slices/lodgeAISlice";
import { LodgeAIModalType } from "@/store/slices/types/lodgeAITypes";
import { ErrorModal } from "./ErrorModal";
import { QueueModal } from "./QueueModal";
import { AutomationModal } from "./AutomationModal";

const LodgeAIModal = () => {
  // This is a ref for the modal overflow component,
  // it is used for scrolling to the bottom of the modal.
  const modalOverflowRef = useRef<HTMLDivElement>(null);
  const { modalType, isOpen } = useSelector(lodgeAISelector);

  if (!isOpen || !modalType) return null;

  return (
    <Modal aria-labelledby="modal-title" open={!!isOpen}>
      <ModalOverflow ref={modalOverflowRef}>
        {modalType === LodgeAIModalType.Error && <ErrorModal />}
        {modalType === LodgeAIModalType.Queue && <QueueModal />}
        {modalType === LodgeAIModalType.Automation && <AutomationModal modalOverflowRef={modalOverflowRef} />}
      </ModalOverflow>
    </Modal>
  );
};

export { LodgeAIModal };
